import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=ecb4ded2&scoped=true"
import script from "./TemplateItem.vue?vue&type=script&lang=js"
export * from "./TemplateItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=ecb4ded2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb4ded2",
  null
  
)

export default component.exports